import { render } from "./StringView.vue?vue&type=template&id=04b56410&scoped=true"
import script from "./StringView.vue?vue&type=script&lang=js"
export * from "./StringView.vue?vue&type=script&lang=js"

import "./StringView.vue?vue&type=style&index=0&id=04b56410&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b56410"]])

export default __exports__